import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';
import { TrackContactCreationState } from '../../types/trackContactCreation/trackContactCreation.types';

// Base selector
const selectTrackContactCreationState = (
  state: RootState
): TrackContactCreationState => state.trackContactCreation;

// Memoized selectors
export const selectTrackContactCreations = createSelector(
  [selectTrackContactCreationState],
  (trackContactCreationState) => trackContactCreationState.trackContactCreations
);

export const selectTrackContactCreationLoading = createSelector(
  [selectTrackContactCreationState],
  (trackContactCreationState) => trackContactCreationState.loading
);

export const selectTrackContactCreationError = createSelector(
  [selectTrackContactCreationState],
  (trackContactCreationState) => trackContactCreationState.error
);

export const selectTrackContactCreationPagination = createSelector(
  [selectTrackContactCreationState],
  (trackContactCreationState) => trackContactCreationState.pagination
);

// Derived selectors
export const selectTrackContactCreationTotal = createSelector(
  [selectTrackContactCreationPagination],
  (pagination) => pagination.total
);

export const selectTrackContactCreationCurrentPage = createSelector(
  [selectTrackContactCreationPagination],
  (pagination) => pagination.page
);

export const selectTrackContactCreationTotalPages = createSelector(
  [selectTrackContactCreationPagination],
  (pagination) => pagination.totalPages
);
